module.exports = __webpack_public_path__ + "media/forest_of_light.85ac99fc.ogg";